
  <ng-template class="modal-center" #acceptModal>
     <div class="modal-header bg-light modal-dialog-centered">
      <div class="height-auto">
       <h4 class="modal-title" >
         {{ 'home.quote.Acceptoffer' | cxTranslate }}
       </h4>
      </div>
       <div class="modal-body bg-light text-center">
       <p>{{ 'home.quote.Thisaccept' | cxTranslate }}</p>
       <p class="xs-semibold-font">{{acceptTxt}}</p>
    </div>
     </div>
     <div class="modal-footer bg-light">
       <div class="form-group">
         <button class="btn btn-block btn-primary btn-lg" type="submit" data-dismiss="modal" (click)="editQuote(productInfo)" [disabled]="disabledBtn">
           {{ 'home.quote.Iaccept' | cxTranslate }}
         </button>
         <button class="btn btn-block btn-secondary btn-lg" type="submit" data-dismiss="modal" (click)="close()">
           {{ 'home.quote.Close' | cxTranslate }}
         </button>
       </div>
     </div>
</ng-template>
